/**
 * How many loyalty coins the customer may burn on this order: the lesser of their balance and the tenant's
 * ``max_redeem_pct_of_order`` of the item subtotal (after a coupon, except a FREE_DELIVERY one). This is only the
 * slider's upper bound — the server re-validates every redemption (coins_router.compute_redemption).
 *
 * Previously the same formula was written out separately in CartPage and CheckoutPage; both now call this.
 */
export function coinRedeemCap(coinsConfig, coinsBalance, totals) {
    if (!coinsConfig?.enabled || !coinsBalance) return 0;
    const t = totals || {};
    const pct = Number(coinsConfig.max_redeem_pct_of_order || 20);
    const rupeePerCoin = Number(coinsConfig.rupee_per_coin || 1);
    const couponDisc = Number(t.coupon_discount || 0);
    const subtotalForCap = Math.max(0, (t.subtotal || 0) - (t.coupon_kind === "FREE_DELIVERY" ? 0 : couponDisc));
    const rupeeCap = subtotalForCap * pct / 100;
    const coinCap = Math.floor(rupeeCap / rupeePerCoin);
    return Math.min(coinsBalance, coinCap);
}

/** The subtotal the coin cap is computed on (shown by the coins block). */
export function coinCapSubtotal(totals) {
    const t = totals || {};
    return Math.max(0, (t.subtotal || 0) - (t.coupon_kind === "FREE_DELIVERY" ? 0 : Number(t.coupon_discount || 0)));
}

export const coinRedeemMin = (coinsConfig) => Number(coinsConfig?.min_redeem_coins || 100);
